<template>
    <div class="curtain-grey">
        <RemindWaitDate v-if="waitDateState"
                        @closeEvent="switchRemind"
                        @submitEvent="saveRemind($event)"
        />
        <RemindAllDate v-if="allDateState"
                       @closeEvent="switchRemind"
                       @submitEvent="saveRemind($event)"
        />
        <RemindTimeDate v-if="timeDateState"
                        @closeEvent="switchRemind"
                        @submitEvent="saveRemind($event)"
        />
        <div class="body-remind" v-show="bodyState">
            <div class="border-remind">
                <div class="text-title">设置提醒</div>
                <div class="items-remind scrollbar">
                    <div class="item-remind">
                        <div class="my-cursor" :class="[
                            {'icon-option-true': remindCount === 0},
                            {'icon-option-false': remindCount > 0}
                        ]" @click.stop="cancelRemind"></div>
                        <div class="text-remind">无提醒</div>
                    </div>

                    <div class="item-remind" v-for="(item, index) in remindItems">
                        <div class="my-cursor" :class="[
                            {'icon-option-true': item.state},
                            {'icon-option-false': !item.state}
                        ]" @click.stop="selectRemind(item)"></div>
                        <div class="text-remind">{{ item.text }}</div>
                        <div class="icon-delete my-cursor" v-if="item.delete" @click.stop="deleteRemind(item.state, index)"></div>
                    </div>
                </div>
                <div class="custom-remind my-cursor" @click.stop="switchRemind">
                    <div class="icon-create"></div>
                    <div class="text-create">自定义提醒</div>
                </div>
                <div class="button-items">
                    <div class="button-close my-cursor" @click.stop="close">取消</div>
                    <div class="button-submit my-cursor" @click.stop="submit">保存</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import RemindWaitDate from "@/pages/List/MatterInfo/RemindWaitDate";
import RemindAllDate from "@/pages/List/MatterInfo/RemindAllDate";
import RemindTimeDate from "@/pages/List/MatterInfo/RemindTimeDate";
export default {
    name: "SettingRemind",
    components: {
        RemindWaitDate,
        RemindAllDate,
        RemindTimeDate,
    },
    data(){
        return {
            waitDateState: false,
            allDateState: false,
            timeDateState: false,
            bodyState: true,
            remindItems: [],
            remindCount: 0,
            hoveIndex: 0,

        }
    },
    props: {
        startDate: {
            type: String,
            default: "",
        },
        startTime: {
            type: Number,
            default: -1,
        },
        remindTimes: {
            type: String,
            default: "",
        },
        userRole: {
            type: String,
            default: "normal",
        },
    },
    methods: {
        close: function(){
            this.$emit("closeEvent");
        },
        submit: function(){
            let remindTimes = [];
            this.remindItems.forEach((item)=>{
                if(item.state){
                    remindTimes.push(item.number);
                }
            })
            this.$emit("submitEvent", remindTimes.join(","));
            this.close();
        },
        switchRemind: function(){

            if(this.startDate === ""){
                // 待办
                this.waitDateState = !this.waitDateState;
            }else if(this.startTime === -1){
                // 全天
                this.allDateState = !this.allDateState;
            }else{
                // 时间点、时间段
                this.timeDateState = !this.timeDateState;
            }
            this.bodyState = !this.bodyState;
        },
        cancelRemind: function(){
            this.remindItems.forEach((item)=>{
                if(item.state){
                    item.state = false;
                }
            })
            this.remindCount = 0;
        },
        selectRemind: function(item){
            if(item.state){
                item.state = false;
                this.remindCount --;
            }else{
                // vip 弹窗
                if(this.userRole === "normal" && this.remindCount >= 2){
                    // 弹出Vip弹窗
                    this.$PopupToast("非会员最多设置两个提醒");
                    return
                }
                if(this.remindCount < 5){
                    item.state = true;
                    this.remindCount ++;
                }else{
                    this.$PopupToast("最多设置5个提醒");
                }
            }
        },
        deleteRemind: function(state, index){
            if(state){
                this.remindCount --;
            }
            this.remindItems.splice(index, 1);
        },
        formatWaitItem: function(item){
            let remindDate = new Date("2000-01-01 00:00:00");
            remindDate = new Date(remindDate.getTime() + item * 60 * 1000);
            remindDate = Solar.fromDate(remindDate);
            const dateString = remindDate.getYear() + "年" + remindDate.getMonth() + "月" + remindDate.getDay() + "日";
            const timeString = remindDate.toYmdHms().slice(11,16);
            return {
                number: item,
                text: dateString + " " + timeString,
                date: remindDate.toYmd(),
                hour: remindDate.getHour(),
                minute: remindDate.getMinute(),
                state: true,
                delete: true,
            }
        },
        formatAllItem: function(item){
            const dayNum = Math.floor(item / 1440);
            const minuteNum = item % 1440;

            const hour = this.$Utils.addZero(Math.floor(minuteNum / 60));
            const minute = this.$Utils.addZero(minuteNum % 60);
            let text;
            if(dayNum === 0){
                text = "当天 ";
            }else{
                text = "提前" + dayNum + "天 ";
            }
            text = text + hour + ":"+ minute;
            return {
                number: item,
                text: text,
                day: dayNum,
                hour: hour,
                minute: minute,
                state: true,
                delete: true,
            }
        },
        formatTimeItem: function(item){
            console.log(item);
            const dayNum = Math.floor(item / 1440);
            const minuteNum = item % 1440;
            const hour = Math.floor(minuteNum / 60);
            const minute = minuteNum % 60;
            let text;
            if(item === 0){
                text = "准时提醒"
            }else{
                text = "提前";
                if(dayNum > 0){
                    text = text + dayNum + "天";
                }
                if(hour > 0){
                    text = text + hour + "小时";
                }
                if(minute > 0){
                    text = text + minute + "分钟";
                }
            }
            console.log(minute, text);
            return {
                number: item,
                text: text,
                day: dayNum,
                hour: hour,
                minute: minute,
                state: true,
                delete: true,
            }
        },
        saveRemind: function(e){

            if(this.userRole === "normal" && this.remindCount >= 2){
                // 弹出Vip弹窗
                this.$PopupToast("非会员最多设置两个提醒");
                return
            }else if(this.remindCount >= 5){
                this.$PopupToast("最多设置5个提醒");
                return
            }
            let isPush = true;
            this.remindItems.forEach((item)=>{
               if(item.number === e){
                   isPush = false;
                   if(!item.state){
                       item.state = true;
                       this.remindCount ++;
                   }
               }
            })
            if(!isPush){
                this.$PopupToast('已创建并选中');
                return
            }
            if(this.waitDateState){
                this.remindItems.push(this.formatWaitItem(e));
            }else if(this.allDateState){
                this.remindItems.push(this.formatAllItem(e));
            }else{
                this.remindItems.push(this.formatTimeItem(e));
            }
            this.remindItems.sort((nextItem, item)=>{
                return nextItem.number - item.number
            })
            this.remindCount ++;

        },

    },
    mounted: function(){
        let minutes;
        if(this.remindTimes === ""){
            minutes = [];
        }else{
            minutes = this.remindTimes.split(",");
        }
        let remindItems;

        if(this.startDate === ""){
            // 待办
            remindItems = [];

        }else if(this.startTime === -1){
            // 全天
            remindItems = [
                {
                    number: 540,
                    text: "当天 09:00",
                    day: 0,
                    hour: "09",
                    minute: "00",
                    state: false,
                    delete: false,
                },
                {
                    number: 600,
                    text: "当天 10:00",
                    day: 0,
                    hour: "10",
                    minute: "00",
                    state: false,
                    delete: false,
                },
                {
                    number: 1980,
                    text: "提前1天 10:00",
                    day: 0,
                    hour: "10",
                    minute: "00",
                    state: false,
                    delete: false
                },
                {
                    number: 10640,
                    text: "提前1周 10:00",
                    day: 0,
                    hour: "10",
                    minute: "00",
                    state: false,
                    delete: false
                },
            ];
        }else{
            // 时间点、时间段
            remindItems = [
                {
                    number: 0,
                    text: "准时提醒",
                    day: 0,
                    hour: "00",
                    minute: "00",
                    state: false,
                    delete: false
                },{
                    number: 5,
                    text: "提前5分钟",
                    day: 0,
                    hour: "00",
                    minute: "05",
                    state: false,
                    delete: false
                },{
                    number: 30,
                    text: "提前30分钟",
                    day: 0,
                    hour: "00",
                    minute: "30",
                    state: false,
                    delete: false
                },{
                    number: 60,
                    text: "提前1小时",
                    day: 0,
                    hour: "01",
                    minute: "00",
                    state: false,
                    delete: false
                },
            ];
        }
        minutes.forEach((item)=>{
            item = parseInt(item);
            let insert = true;
            remindItems.forEach((remindItem)=>{
                if(remindItem.number === item){
                    remindItem.state = true;
                    insert = false;
                }
            })
            if(!insert){
                // 默认
                return
            }
            // 生成
            let remindItem;
            if(this.startDate === ""){
                // 待办
                remindItem = this.formatWaitItem(item);
            }else if(this.startTime === -1){
                // 全天
                remindItem = this.formatAllItem(item);
            }else{
                // 时间点、时间段
                remindItem = this.formatTimeItem(item);
            }
            remindItems.push(remindItem);

        })
        this.remindItems = remindItems;
        this.remindCount = minutes.length;
    },
}
</script>

<style scoped>

div.body-remind{
    width: 4.2rem;
    height: auto;
    padding: 0.08rem;
    background: #FFFFFF;
    border-radius: 0.3rem;
    margin: 20vh auto auto;
}
div.border-remind{
    width: 100%;
    height: auto;
    padding: 0.16rem 0.2rem 0.3rem;
    border: 0.02rem solid #000000;
    border-radius: 0.26rem;
    box-sizing: border-box;
}
div.text-title{
    width: 100%;
    height: 0.22rem;
    font-weight: bold;
    font-size: 0.18rem;
    color: #000000;
    line-height: 0.22rem;
    text-align: center;
}
div.items-remind{
    width: 100%;
    max-height: 2rem;
    display: flex;
    flex-direction: column;
    gap: 0.24rem;
    margin: 0.24rem auto;
    overflow-y: scroll;
}
div.scrollbar{
    padding-right: 0.1rem;
    overflow-y: scroll;
}
div.scrollbar::-webkit-scrollbar{
    background: transparent;
}

div.item-remind{
    width: 100%;
    height: 0.24rem;
    display: flex;
    gap: 0.11rem;
    align-items: center;
}
div.item-remind:hover div.icon-delete{
    visibility: visible;
}
div.icon-option-true,div.icon-option-false{
    width: 0.22rem;
    height: 0.22rem;
}
div.icon-option-true{
    background: url("../../../assets/images/Public/icon-option-true.png");
    background-size: cover;
}
div.icon-option-false{
    background: url("../../../assets/images/Public/icon-option-false.png");
    background-size: cover;
}
div.text-remind{
    flex: 1;
    font-weight: bold;
    font-size: 0.16rem;
    color: #000000;
    text-align: left;
}
div.icon-delete{
    width: 0.24rem;
    height: 0.24rem;
    background: url("../../../assets/images/List/icon-delete.png");
    background-size: cover;
    visibility: hidden;
}
div.custom-remind{
    width: 100%;
    height: 0.42rem;
    background: rgba(254, 228, 148, 0.5);
    border-radius: 0.1rem;
    display: flex;
    gap: 0.1rem;
    justify-content: center;
    align-items: center;
}
div.icon-create{
    width: 0.16rem;
    height: 0.16rem;
    background: url("../../../assets/images/List/icon-create.png");
    background-size: cover;
}
div.text-create{
    font-weight: bold;
    font-size: 0.16rem;
    color: #000000;
    text-align: left;
}

div.button-items{
    width: 100%;
    height: 0.48rem;
    margin-top: 0.4rem;
    display: flex;
    box-sizing: border-box;
    justify-content: space-between;
}
div.button-submit, div.button-close{
    width: 1.4rem;
    height: 0.48rem;
    border-radius: 0.38rem;
    border: 0.02rem solid #000000;
    font-size: 0.16rem;
    line-height: 0.43rem;
    text-align: center;
}

div.button-close{
    background: #FFFFFF;
    box-shadow: inset 0 -0.05rem 0 0 #9F9F9F;
    color: #000000;
}
div.button-submit{
    background: #FC8470;
    box-shadow: inset 0 -0.05rem 0 0 #FFF4C9;
    color: #FFFFFF;
}
</style>